var _path, _path2, _path3, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75781 10.4648H26.7578C27.736 10.4648 28.3438 10.4675 28.7858 10.5269C29.1847 10.5806 29.2635 10.6598 29.2869 10.6833L29.2881 10.6845L29.2893 10.6857C29.3129 10.7092 29.3921 10.788 29.4457 11.1869C29.5052 11.6288 29.5078 12.2367 29.5078 13.2148V21.6094V22.0039C29.5078 24.8677 29.5052 26.8897 29.2993 28.421C29.0983 29.9163 28.7243 30.7549 28.1166 31.3627C27.5089 31.9704 26.6702 32.3443 25.1749 32.5454C23.6437 32.7513 21.6216 32.7539 18.7578 32.7539H12.7578C9.89405 32.7539 7.87197 32.7513 6.34074 32.5454C4.84547 32.3443 4.00677 31.9704 3.39906 31.3627C2.79134 30.7549 2.41737 29.9163 2.21634 28.421C2.01047 26.8897 2.00781 24.8677 2.00781 22.0039V13.2148C2.00781 12.2367 2.01047 11.6288 2.06989 11.1869C2.12352 10.7879 2.20272 10.7092 2.22628 10.6857C2.2267 10.6853 2.2271 10.6849 2.22748 10.6845C2.22787 10.6841 2.22827 10.6837 2.22868 10.6833C2.25212 10.6598 2.33092 10.5806 2.72983 10.5269C3.1718 10.4675 3.77967 10.4648 4.75781 10.4648Z",
    stroke: "#613323",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82031 24.7891L9.20642 25.1975C12.9191 29.1251 19.2271 28.9341 22.6953 24.7891V24.7891",
    stroke: "#613323",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2578 9.21484C23.2578 5.07271 19.8999 1.71484 15.7578 1.71484C11.6157 1.71484 8.25781 5.07271 8.25781 9.21484",
    stroke: "#613323",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2578,
    cy: 17.3594,
    r: 2,
    fill: "#613323"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2578,
    cy: 17.3594,
    r: 2,
    fill: "#613323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.96947a8e27f49a0422d70c85b7b266f0.svg";
export { ForwardRef as ReactComponent };